import TextAreaInput from '@components/textarea/TextArea';
import { useRequest } from '@stores';

const PermitsDischarges = ({ handleChange = () => {} }) => {
  const isReadOnly = useRequest((state) => state.isFormReadOnly);

  return (
    <>
      <div>
        <TextAreaInput
          name='dischargeMaterialSource'
          label='Describe the source of the material'
          onChange={handleChange}
          readOnly={isReadOnly}
          required
        />
      </div>
      <div>
        <TextAreaInput
          name='dischargeReason'
          label='Reason(s) for Discharge'
          tooltip='If the activity involves the discharge of dredged and/or fill material into a wetland or other waterbody, including the temporary placement of material, explain the specific purpose of the placement of the material (such as erosion control).'
          onChange={handleChange}
          readOnly={isReadOnly}
          required
        />
      </div>
    </>
  );
};

export default PermitsDischarges;
